import { createApp, h } from 'vue'
import { createInertiaApp, Head, Link } from '@inertiajs/vue3'
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers'

import filters from './filters'
import { registerPlugins } from '@core/utils/plugins'
import BlankLayout from './layouts/BlankLayout.vue'
import DefaultLayout from './layouts/DefaultLayout.vue'

// Styles
import '@core-scss/template/index.scss'
import '@styles/styles.scss'
import '../css/tailwind.css'

const appName = window.document.getElementsByTagName('title')[0]?.innerText || 'Laravel'

createInertiaApp({
  progress: false,
  title: (title) => {
    return title ? `${title} - ${appName}` : appName
  },
  resolve: (name) => {
    const page = resolvePageComponent(`./pages/${name}.vue`, import.meta.glob('./pages/**/*.vue'))
    page.then((module) => {
      module.default.layout = module.default.layout || (name.startsWith('auth/') ? BlankLayout : DefaultLayout)
    })
    return page
  },
  setup({ el, App, props, plugin }) {
    const app = createApp({
      render: () => h(App, props)
    })

    registerPlugins(app)

    app.component('Head', Head)
    app.component('Link', Link)
    app.component('InertiaHead', Head)
    app.component('InertiaLink', Link)

    app.use(plugin)

    app.mount(el)

    app.config.globalProperties.$filters = filters
  },
})
